import styled from 'styled-components';

export default styled.div`
  pointer-events: auto;
  display: flex;
`;
